import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import authentication from "@irati/auth"
import {H1} from "@irati/ui/src/Typography"

import {SectionHeader, DesktopOnlyButton} from "../styled"

interface Props {
  onClickEdit?: () => void
  onExitEdit?: () => void | null
}

const CompanyNewsTitle: FC<Props> = ({onClickEdit, onExitEdit = null}) => {
  const businessName = authentication.business().businessName
  const isAdmin = authentication.isGlobalAdmin()
  return (
    <SectionHeader>
      <H1>
        <FormattedMessage id="platform.homepage.companyNews.title" values={{tenant: businessName}} />
      </H1>
      {isAdmin && !onExitEdit && (
        <DesktopOnlyButton primary onClick={onClickEdit}>
          <FormattedMessage id="platform.homepage.companyNews.edit" values={{tenant: businessName}} />
        </DesktopOnlyButton>
      )}
      {isAdmin && onExitEdit && (
        <DesktopOnlyButton primary onClick={onExitEdit}>
          <FormattedMessage id="platform.homepage.companyNews.exit" />
        </DesktopOnlyButton>
      )}
    </SectionHeader>
  )
}

export default CompanyNewsTitle
